import { render, staticRenderFns } from "./ExpiryTimer.vue?vue&type=template&id=1532b8f0&"
import script from "./ExpiryTimer.vue?vue&type=script&lang=ts&"
export * from "./ExpiryTimer.vue?vue&type=script&lang=ts&"
import style0 from "./ExpiryTimer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports